import {Component, ComponentRef, Input, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation} from '@angular/core';
import {BotatoChatInputResolverService} from './botato-chat-input-resolver.service';
import {BotatoChatInputDirective} from './botato-chat-input.directive';
import {InputComponent} from './input-type/input.component';
import {
    DialogConfigInputOptionsTextInput,
    DialogConfigInputOptionType
} from 'botato-botengine-browser/botato/botato-botengine/source/Core/DialogConfig/DialogConfig.js';

@Component({
    selector: 'botato-chat-input',
    templateUrl: './botato-chat-input.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BotatoChatInputComponent implements OnChanges {

    @ViewChild(BotatoChatInputDirective, {static: true})
    public inputHost!: BotatoChatInputDirective;
    @Input()
    public type!: string;
    @Input()
    public inputComponentFocus: boolean | undefined;
    @Input()
    public options: DialogConfigInputOptionType | undefined;
    private currentInputType: string | undefined;
    private currentComponentInstance: ComponentRef<InputComponent<DialogConfigInputOptionType>> | undefined;

    constructor(private chatInputComponentTypeResolver: BotatoChatInputResolverService) {
    }

    public ngOnChanges(changes: SimpleChanges): void {

        if (changes.type !== undefined) {
            const newInputType: string = changes.type.currentValue as string;

            if (newInputType !== this.currentInputType) {
                this.inputHost.viewContainerRef.remove();

                if (newInputType !== 'none') {
                    const componentInstance = this.createInputHost(newInputType);

                    componentInstance.setInput('inputOptions', this.options);
                    componentInstance.setInput('inputComponentFocus', this.inputComponentFocus);
                }

                this.currentInputType = newInputType;
            }
        }

        if (changes.options !== undefined && this.currentComponentInstance !== undefined) {
            if (this.currentInputType === 'text') {
                this.checkTextInputOptionChanges(this.currentInputType, this.currentComponentInstance, changes.options.currentValue as DialogConfigInputOptionsTextInput);
            }
            // setInput (instead of a plain property write) marks the OnPush input component dirty so the new options render
            this.currentComponentInstance.setInput('inputOptions', this.options);
            this.currentComponentInstance.setInput('inputComponentFocus', this.inputComponentFocus);
        }
    }

    // link with a problem
    private checkTextInputOptionChanges(currentInputType: string, currentComponentInstance: ComponentRef<InputComponent<DialogConfigInputOptionType>>, options: DialogConfigInputOptionsTextInput): void {
        const currentInputOptions = currentComponentInstance.instance.inputOptions as DialogConfigInputOptionsTextInput | undefined;
        if (options.enableVoice !== currentInputOptions?.enableVoice) {
            this.inputHost.viewContainerRef.remove();
            this.createInputHost(currentInputType);
        }
        if (options.defaultText !== currentInputOptions?.defaultText) {
            this.inputHost.viewContainerRef.remove();
            this.createInputHost(currentInputType);
        }
    }

    private createInputHost(inputType: string): ComponentRef<InputComponent<DialogConfigInputOptionType>> {
        const componentType = this.chatInputComponentTypeResolver.resolve(inputType);
        this.currentComponentInstance = this.inputHost.viewContainerRef.createComponent(componentType);
        return this.currentComponentInstance;
    }
}
